@let status = statusSg();

@if (status.loading) {
  <atn-ds-loader type="table" />
} @else {
  <div class="atn-ds-table-status">
    @if (status.tool; as tool) {
      <atn-ds-empty-state
        layout="h"
        [action]="tool.label"
        [description]="status.description"
        [title]="status.title"
        [type]="status.illustration"
        (action)="tool.onClick()"
      />
    } @else {
      <atn-ds-empty-state
        layout="h"
        [description]="status.description"
        [title]="status.title"
        [type]="status.illustration"
      />
    }
  </div>
}
